import React from 'react';
import { browserHistory } from 'react-router';
import { applicationRoutes } from '../../utils/config/applicationRoutesConfig';

const redirectHome = () => {
  browserHistory.replace(applicationRoutes.home || '/');
};

const getEventIdFromLocation = () =>
  typeof window !== 'undefined'
    ? window.location.pathname.split('/').filter(Boolean).pop()
    : null;

const validateAccess = (store) => {
  const state = store.getState();
  const user = state?.user?.data?.result;

  if (!user?.profileId) {
    redirectHome();
    return false;
  }

  const eventId = getEventIdFromLocation();
  if (!eventId) return true;

  const events = state?.eventDetail?.data?.eventList;
  if (!events?.length) return true;

  const allowed = events.some(
    (event) => String(event.eventId || event.id) === String(eventId)
  );

  if (!allowed) redirectHome();

  return allowed;
};

class ProtectedRouteWrapper extends React.Component {
  componentDidMount() {
    validateAccess(this.props.store);
  }

  componentDidUpdate(prevProps) {
    const prevState = prevProps.store.getState();
    const currentState = this.props.store.getState();

    if (prevState?.eventDetail?.data !== currentState?.eventDetail?.data) {
      validateAccess(this.props.store);
    }
  }

  render() {
    const state = this.props.store.getState();

    if (!state?.user?.data?.result?.profileId) {
      return null;
    }

    return this.props.children;
  }
}

export default ProtectedRouteWrapper;
